import Vue from "vue";

export default {
	state: {
		suppliers: [],
		bankPagination: {},
		contactPagination: {}
	},
	mutations: {
		setSuppliersOnState(state, suppliers) {
			state.suppliers = suppliers;
		},
		setSuppliersEntailsOnState(state, supplierEntails) {
			state.supplierEntails = supplierEntails;
		},
		setSupplierParentOnState(state, supplierParent) {
			state.supplierParent = supplierParent;
		},
		setBankPaginationOnState(state, bankPagination) {
			state.bankPagination = bankPagination;
		},
		setContactPaginationOnState(state, contactPagination) {
			state.contactPagination = contactPagination;
		}
	},
	actions: {
		getSuppliers({ commit }) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("supplier")
					.then((response) => {
						let mappedSuppliers = mapToFront(response.data.data);
						commit("setSuppliersOnState", mappedSuppliers);
						this.state.loading = false;
						resolve(mappedSuppliers);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getSupplierData(_, dataObject) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("supplier/checkSupplierData", dataObject)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		updateSupplierStatus(_, statusData) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("supplier/status", statusData)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		updateSupplierClientAddressStatus(_, dataObject) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("supplier/supplierClientAddress", dataObject)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		updateSupplierClientBankStatus(_, dataObject) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("supplier/supplierClientBank", dataObject)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getFilteredSuppliers({ commit }, supplierData) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("supplier/filtered", supplierData)
					.then((response) => {
						let mappedSuppliers = mapFilteredSuppliers(response.data.data);
						commit("setSuppliersOnState", mappedSuppliers);
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getSupplierEntails({ commit }, idSupplier) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("supplier/entail/" + idSupplier)
					.then((response) => {
						commit("setSuppliersEntailsOnState", response.data.data);
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getSupplierParent({ commit }, idSupplier) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("supplier/parent/" + idSupplier)
					.then((response) => {
						commit("setSupplierParentOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						console.error(error);
						reject();
					})
					.finally(() => {
						this.state.loading = false;
					});
			});
		},
		getSupplierDetails({ commit }, idSupplier) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("supplier/details", idSupplier)
					.then((response) => {
						this.state.loading = false;
						commit("setBankPaginationOnState", response.data.data.bankPagination);
						commit("setContactPaginationOnState", response.data.data.contactPagination);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getBankListBySupplier({ commit }, filterBank) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("supplier/bankList", filterBank)
					.then((response) => {
						this.state.loading = false;
						commit("setBankPaginationOnState", response.data.data.bankPagination);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getContactListBySupplier({ commit }, filterContact) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("supplier/contactList", filterContact)
					.then((response) => {
						this.state.loading = false;
						commit("setContactPaginationOnState", response.data.data.contactPagination);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getSupplierDetailsForRehomologation({ commit }, dataObject) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.post("supplier/supplierRehomologation", dataObject)
					.then((response) => {
						this.state.loading = false;
						commit("setInviteOnState", response.data.data);
						commit("setSpecificRequirementsOnState", response.data.data.specificRequirement);
						commit("setGeneralRequirementsOnState", response.data.data.generalRequirement);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getAllSupplierStatus() {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get(`supplier/supplierStatus/all`)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		}
	},
	getters: {
		suppliers({ suppliers }) {
			return suppliers;
		},
		actualSupplier(state) {
			return state.suppliers.find((supplier) => supplier.idUser == state.actualSupplier.idUser);
		},
		supplierEntails({ supplierEntails }) {
			return supplierEntails;
		},
		supplierParent({ supplierParent }) {
			return supplierParent;
		},
		bankPagination({ bankPagination }) {
			return bankPagination;
		},
		contactPagination({ contactPagination }) {
			return contactPagination;
		}
	}
};

function mapToFront(supplierList) {
	supplierList.forEach((supplier) => {
		supplier.activeStatus = supplier.isActive ? "Ativo" : "Inativo";
	});
	return supplierList;
}

function mapFilteredSuppliers(filteredSuppliers) {
	return filteredSuppliers.map((supplier) => {
		supplier.cnpjCpf = Vue.prototype.$functions.cnpjCpfFormatFromBack(supplier.cnpjCpf);
		return supplier;
	});
}
